import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../constants';

import { BaseContainer } from '../Containers';
import { TopSection } from './TopSection';
import { TipSwiper } from './TipSwiper';
import { AppointmentSection } from './AppointmentSection';
import { ActionBanner } from './ActionBanner';
import { LifestyleSection } from './LifestyleSection';
import { SightInfoSection } from './SightInfoSection';
import { AppHeader } from '../AppHeader';

const Row = styled.div``;
const Column = styled.div``;

interface IProps {
    className?: string;
    totalSteps: number;
    onCloseButtonClick?(): void;
}

const BaseResultView = ({
    className,
    totalSteps,
    onCloseButtonClick,
}: IProps) => (
    <div className={className}>
        <AppHeader
            totalSteps={totalSteps}
            closeButtonOnly
            onCloseButtonClick={onCloseButtonClick}
        />
        <BaseContainer>
            <TopSection />
            <Row>
                <AppointmentSection />
                <Column>
                    <TipSwiper />
                    <ActionBanner />
                </Column>
            </Row>
            <Row>
                <LifestyleSection />
                <SightInfoSection />
            </Row>
        </BaseContainer>
    </div>
);

export const ResultView = styled(BaseResultView)`
    position: relative;

    ${BaseContainer} {
        max-width: 1200px;
        padding: 0;
        position: initial;
    }

    ${AppointmentSection},
    ${TipSwiper},
    ${ActionBanner},
    ${LifestyleSection},
    ${SightInfoSection} {
        margin: 20px;
    }

    @media (${breakpoints.smallMin}) {
        ${Row}, ${Column} {
            display: flex;
        }

        ${Column} {
            flex-direction: column;
        }

        ${TopSection},
        ${AppointmentSection},
        ${TipSwiper},
        ${ActionBanner},
        ${LifestyleSection},
        ${SightInfoSection} {
            margin: 0 0 20px;
        }

        ${AppointmentSection}, ${LifestyleSection} {
            margin-right: 20px;
        }
    }
`;
